import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CodeLegend } from '../../health.model';

@Component({
  selector: 'app-code-legend',
  templateUrl: './code-legend.component.html',
  styles: []
})
export class CodeLegendComponent implements OnInit {

  legendCodes: CodeLegend[];

  constructor(
    private dialogRef: MatDialogRef<CodeLegendComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.legendCodes = this.data.legendCodes;
  }

  closeClick() {
    this.dialogRef.close('Close was clicked.');
  }
}
